// TanStack Query mutation that wraps feedbackApi.submitFeedback.
// Returns stable references via useMutation so callers re-render only on
// state transitions (idle → pending → success/error).

import { useMutation } from '@tanstack/react-query';
import { submitFeedback } from '../api/feedbackApi';
import type { FeedbackValue } from './types';

type SubmitFeedbackVariables = {
  runId: string;
  value: FeedbackValue;
  comment?: string;
};

export function useSubmitFeedback() {
  const mutation = useMutation({
    mutationFn: ({ runId, value, comment }: SubmitFeedbackVariables) =>
      submitFeedback(runId, value, comment),
  });

  return {
    submitFeedback: (runId: string, value: FeedbackValue, comment?: string) =>
      mutation.mutateAsync({ runId, value, comment }),
    isSubmitting: mutation.status === 'pending',
    isSubmitted: mutation.status === 'success',
    error: mutation.error,
    reset: mutation.reset,
  };
}
